import { clone } from 'lodash';
import { translate } from 'shared/services/I18nService';

const key = 'uScope.extensions.pdx.disclaimer-ruo';
const TEMPLATE = `<div class="us-pdx-banner">
    <h4>{{BANNER_TEXT}}</h4>
</div>`;

const defaults = {
  layout: { divClass: 'us-pdx-banner', precinct: 'B', rightOffset: 0, order: 0 }
};

export function PdxBanner (uScope, viewport) {
  if (!isPdxImage(viewport)) {
    return;
  }

  viewport.events.on('viewport:image-opened', init);

  const layout = clone(defaults.layout);
  const viewportDiv = viewport.vpDivGet('outer');
  const content = TEMPLATE.replace('{{BANNER_TEXT}}', translate(key));
  viewportDiv.append(content);

  function init () {
    viewport.overLayout.add(layout);
  }
}

function isPdxImage (viewport) {
  return viewport.xinfo.sessionMode === 'PDX';
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/pdx-support/PdxBanner.js